import { BaseSyntheticEvent, useRef, useState } from 'react';

export const useFormRef = () => {
	const formRef = useRef<HTMLFormElement | null>(null);
	const [isValid, setIsValid] = useState(false);

	const checkValidity = () => {
		setIsValid(!!formRef.current?.checkValidity());
	};

	const onSubmit = (action: (body?: Record<string, any>) => any) => (e: BaseSyntheticEvent) => {
		e.preventDefault();
		// invalidateError();
		if (formRef.current?.checkValidity()) {
			const payload = Object.fromEntries(new FormData(formRef.current as HTMLFormElement));
			action({ ...payload });
		}
	};
	return {
		formRef,
		isValid,
		checkValidity,
		onSubmit
	}
};
